<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @use './styles/index'; // 全局自定义的css样式（normalize.css 已在 main.js 中引入）
</style>
